import { Link, useLocation } from '@remix-run/react';

import { PoweredByLogos } from '../PoweredByLogos';

interface ZenLayoutProps {
  children: React.ReactNode;
}

export function ZenLayout({ children }: ZenLayoutProps) {
  const location = useLocation();
  const newStyledRoutes = ['/login', '/signup', '/forgot-password', '/set-password'];
  const isLogin = newStyledRoutes.includes(location.pathname);
  const isSignup = location.pathname === '/signup';
  const cardMaxWidth = isSignup ? 'max-w-2xl' : 'max-w-lg';
  // Wide zen container: pages whose content manages its own width (the referral
  // form matches the 1000px embed layout, #1155).
  const WIDE_ZEN_ROUTES = ['/baa', '/referrals/new'];
  const isWide = WIDE_ZEN_ROUTES.includes(location.pathname);

  if (isLogin) {
    return (
      <div className="min-h-screen flex flex-col md:flex-row md:items-center bg-gradient-to-b from-zen-300 to-zen-light justify-center">
        <div className="w-full md:w-[680px] flex flex-col items-center justify-center px-4 py-8 md:px-0">
          <div className={`w-full ${cardMaxWidth} bg-white shadow-lg rounded-xl p-8`}>
            <div className="flex justify-center mb-8">
              <Link to="/" className="inline-block">
                <img src="/logo.svg" alt="ToothReferral" className="h-16" />
              </Link>
            </div>
            {/* Form content */}
            <div>{children}</div>
          </div>

          <div className={`w-full ${cardMaxWidth}`}>
            <PoweredByLogos className="mt-6" showBackground={false} gap="gap-x-8 gap-y-5" />
          </div>
        </div>

        <div className="hidden md:flex flex-col justify-center items-center relative w-[680px]">
          <div className=" flex flex-col items-center justify-center px-8">
            <div className="text-5xl font-bold text-center mb-8">
              <span className="text-white">Your </span>
              <span className="text-purple-600">Networking </span>
              <span className="text-white">is Working</span>
            </div>
            <img src="/tablet-crop.png" alt="Tablet" className="w-[500px]" />
            <div className="text-[120px] font-bold text-center bg-gradient-to-b from-purple-600 to-blue-400 bg-clip-text text-transparent mb-8">
              24/7
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-zen-300 to-zen-light">
      {/* Main content */}
      <main className="px-4 py-8">
        <div
          className={`${isWide ? 'max-w-5xl' : 'max-w-2xl'} mx-auto bg-white rounded-lg shadow-lg`}
        >
          {/* Logo centered at the top of the white box */}
          <div className="flex justify-center border-b border-gray-100 p-6">
            <Link to="/" className="inline-block">
              <img src="/logo.svg" alt="ToothReferral" className="h-24" />
            </Link>
          </div>

          {/* Form content */}
          <div className="p-8">{children}</div>
        </div>
      </main>
    </div>
  );
}
